import { apiService } from "./api";

export interface LoginRequest {
  username: string;
  password: string;
}

export interface AuthResponse {
  accessToken: string;
  admin: {
    id: string;
    username: string;
    email: string;
    fullName: string | null;
  };
}

export interface Admin {
  id: string;
  username: string;
  email: string;
  fullName: string | null;
}

export const authService = {
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    return await apiService.post<AuthResponse>("/admin/auth/login", credentials);
  },

  async refreshToken(): Promise<AuthResponse | null> {
    try {
      return await apiService.post<AuthResponse>("/admin/auth/refresh");
    } catch (error) {
      return null;
    }
  },

  async logout(): Promise<void> {
    // Clear token from storage
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_data");
  },

  getToken(): string | null {
    return localStorage.getItem("admin_token");
  },

  getAdmin(): Admin | null {
    const adminData = localStorage.getItem("admin_data");
    if (!adminData) return null;
    try {
      return JSON.parse(adminData);
    } catch {
      return null;
    }
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },

  setAuthData(authResponse: AuthResponse): void {
    localStorage.setItem("admin_token", authResponse.accessToken);
    localStorage.setItem("admin_data", JSON.stringify(authResponse.admin));
  },
};

